import { render, staticRenderFns } from "./modal_encerrar_consulta_telemedicina.vue?vue&type=template&id=ee944978&scoped=true"
import script from "./modal_encerrar_consulta_telemedicina.vue?vue&type=script&lang=js"
export * from "./modal_encerrar_consulta_telemedicina.vue?vue&type=script&lang=js"
import style0 from "./modal_encerrar_consulta_telemedicina.vue?vue&type=style&index=0&id=ee944978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee944978",
  null
  
)

export default component.exports